import { createFileRoute } from "@tanstack/react-router"
import EventsAnalyticsPage from "@/components/coreAnalytics/events/EventsAnalyticsPage"

export const Route = createFileRoute("/core/analytics/deadlines-and-events")({
  component: EventsAnalyticsPage
})
